import React, { Component } from 'react'
import { Button, Modal} from 'semantic-ui-react'
import {  sendDrNote } from '../../redux/modules/billing';


export default class DrNoteModal extends Component {
 sendMail=()=>{
     alert('Sending email...')
     const {note,selectedPracticeName,  selectedPatient,dispatch} =this.props;
     let title=`Dr Note ${selectedPracticeName} ${selectedPatient.PatNum} ${selectedPatient.LastVisit}\r`
     dispatch(sendDrNote({drNotes:title+'\r'+note}))
 }
    render() {
        const {note,selectedPracticeName,  selectedPatient} =this.props;
        const noteArr=note.split(/(\r\n|\n|\r)/gm)
        return(
            <Modal
                trigger={<Button>Scrolling Content Modal</Button>}
                open={true}
                onClose={() => this.props.hideDrModal()}
                centered={false}
                style = {{ overflow: 'auto' }}
                closeIcon
                size={ "large" }
                className={  "" }
            >
                    <Modal.Header>Dr Note {selectedPracticeName} {selectedPatient.PatNum} ({selectedPatient.LastVisit}) </Modal.Header>

                <Modal.Content scrolling className="pt-0">
                    <Modal.Description className="mt20">
                        {noteArr.map(item=>item.length>2?<div>{item}</div>:"")}
                    </Modal.Description>
                </Modal.Content>


                <Modal.Actions>
                    <Button primary className="mr10" onClick={ () =>this.sendMail() }>
                        Send
                    </Button>
                </Modal.Actions>

            </Modal>
        );
    }
}